/**
 * @name THEME_BREAKPOINT_NAMES
 * @description breakpoint NAMES
 */
export const THEME_BREAKPOINT_NAMES = {
  LG: 'lg',
  SM: 'sm',
  XS: 'xs',
};
